<div class="container-fluid Forgotcomponent">
  <div class="row d-flex justify-content-center" id="mainRow">
    <div class="col-lg-7 px-0" id="carouselDiv">
      <div
        id="carouselExampleControls12"
        class="carousel slide"
        data-bs-ride="carousel"
        data-bs-pause="false"
        data-bs-interval="4000"
      >
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img
              src="../../../../assets/images/image1_1.png"
              class="d-block w-100"
              alt="..."
            />
          </div>
          <div class="carousel-item">
            <img
              src="../../../../assets/images/image2_1.png"
              class="d-block w-100"
              alt="..."
            />
          </div>
          <div class="carousel-item">
            <img
              src="../../../../assets/images/image3_1.png"
              class="d-block w-100"
              alt="..."
            />
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 col-lg-5">
      <div class="row">
        <div class="col-12 text-center mb-4-vw" style="margin-top: 10%">
          <!-- <img src="../../../../assets/images/zoei_logo1.png" width="40%" /> -->
          <img
            src="../../../../assets/images/zoei_logo_black.png"
            width="40%"
          />
          <!-- <img
            src="../../../../assets/images/think_gas2.png"
            width="40%"
          /> -->
        </div>
        <!-- <img src="../../../../assets/images/login_logo.png" width="40%" /> -->
        <div class="col-12 d-flex justify-content-center">
          <div
            class="loginFornt"
            style="font-weight: bold; font-size: 1.736vw; padding-top: 8%"
          >
            Forgot Password
          </div>
        </div>
        <div class="col-2"></div>
        <div class="col-8 mt-5-vw">
          <form autocomplete="off" [formGroup]="ForgotForm">
            <label for="forgotEmail" class="loginFornt fs-16-vw"
              >Enter Registered Email</label
            ><br />
            <input
              type="email"
              id="email"
              (input)="fieldTouched = true"
              name="forgotEmail"
              class="w-100 form-control shadow-none fs-14-vw"
              formControlName="UserEmailId"
              placeholder="Enter Email"
              appDisableAutofill
            />
            <span class="loginFornt fs-14-vw"
              >We will send a verification code to the entered email if it is
              found registered with us.
            </span>
            <br />
            <br />
            <button
              class="btn w-100 mt-3-vw NextButton shadow-none fs-16-vw"
              [ngClass]="fieldTouched ? 'cursor' : 'cursorDisabled'"
              (click)="fieldTouched ? EmailVerify() : ''"
            >
              Next
            </button>
            <button
              class="btn w-100 mt-3-vw BackButton shadow-none fs-16-vw"
              type="submit"
              [routerLink]="['/login']"
            >
              Back
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
